import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\HideItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/HideItemToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/hide'
*/
const HideItemToEnaosController = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: HideItemToEnaosController.url(args, options),
    method: 'post',
})

HideItemToEnaosController.definition = {
    methods: ["post"],
    url: '/api/item/{item}/enaos/{enaos_item}/hide',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\HideItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/HideItemToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/hide'
*/
HideItemToEnaosController.url = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            enaos_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        enaos_item: typeof args.enaos_item === 'object'
        ? args.enaos_item.id
        : args.enaos_item,
    }

    return HideItemToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{enaos_item}', parsedArgs.enaos_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\HideItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/HideItemToEnaosController.php
* @route '/api/item/{item}/enaos/{enaos_item}/hide'
*/
HideItemToEnaosController.post = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: HideItemToEnaosController.url(args, options),
    method: 'post',
})

export default HideItemToEnaosController